import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  CircularProgress,
  Backdrop,
  ClickAwayListener,
  Divider,
  Grid,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';

import Page from 'components/Page';
import CTMap from 'components/CTMap';

import * as OrderAction from 'actions/order-action';
import { getOrderTimingStats, getFilesByOrderId, } from 'services/order-service.js';
import { bindActionCreators } from 'redux';
import { filterOrderDataByTab } from 'utils/filter';
import { formatCurrency } from 'utils/formatter.js';
import { Validate } from 'utils/Validator';

import 'rsuite/dist/rsuite.min.css';
import '../../../styles/rsuite-component.css';
import ToastHandler from 'components/Toast-Handler/toast-handler';

import PageHeader from 'global/PageHeader';
import Notificationbar from 'global/Notificationbar';
import { ArrowDropDown, CloseOutlined, ImportExportOutlined } from '@mui/icons-material';
import Searchbar from 'global/Searchbar';
import DataDialog from 'components/dialogs/DataDialog';
import NotificationDialog from 'components/dialogs/NotificationDialog';
import DispatchGridView from '../views/grid-view';
import DispatchTableView from '../views/table-view';
import OrderStats from '../order-stats';
import InvoiceModal from '../../Accounting/invoice-modal';
import FilesModal from 'components/files-modal';
import ConfirmationDialog from 'components/dialogs/ConfirmationDialog';
import { Calendar } from 'rsuite';
import { SwimlaneHeader } from 'styles/GlobalStyle';
import { tokens } from 'theme/tokens';
import FormDrawer from 'components/FormDrawer';
import ContentDrawer from 'components/ContentDrawer';
import IntermodalLoadForm from '../forms/intermodal-form';
import LoadDetail from '../views/load-detail';

const INTERMODAL_STATUS = ['OPEN', 'PROGRESS', 'YARD', 'DELIVERED', 'COMPLETE'];
const DISPATCH_MODE = ['TODAY', 'ALL ORDERS', 'NO APPOINTMENT ORDERS'];
const SEARCH_FIELDS = [
  { 'name': 'OrderId', 'label': 'Order Id', 'type': 'text' },
  { 'name': 'Terminal/Shipper', 'label': 'Terminal/Shipper', 'type': 'text' },
  { 'name': 'Broker', 'label': 'Broker', 'fieldType': 'text' },
  { 'name': 'Broker W/O Number', 'label': 'Broker Ref. No.', 'type': 'text' },
  { 'name': 'Container Number', 'label': 'Container Num.', 'type': 'text' },
  { 'name': 'LDF', 'label': 'LastFreeDate', 'fieldType': 'type' },
];

const IntermodalDispatch = (props) => {
  const { location } = props; //Navigation Location
  
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const TAB_COLORS = {
    OPEN: colors.info.main,
    PROGRESS: colors.warning.main,
    YARD: colors.error.main,
    DELIVERED: colors.success.main,
    COMPLETE: colors.success.main,
  };

  const getTabColor = (type) =>TAB_COLORS[type] || colors.info.main;
  const dispatch = useDispatch();
  const initState = {
    summary: {
      orderType: '',
      appointment: true,
      brokerId: '',
      broker:'',
      brokerOrderNumber: '',
      orderRate:'',
      fuelCharges:'',
      fuelChargesType: '$',
      extraCharges: null,
      expenses: [],
      orderTotal: null,
      notes: null,
      palletQty: '',
      temperature: '',
      temperatureType: '',
    },
    expense: {
      id: '',
      name: '',
      category:'',
      categoryDescription:'',      
      billableAmount: '',
      companyShare: '',
      driverShare: '',
      isPerDay: false,
      expenseType: 'BILLABLE',
    },
    origin: {
      id: [],
      name: [null],
      appointment: [new Date()],
      openAppointment: [null], // We don't need another boolean. If user enters the data in this field it means we need open appointment.
      puNumber: [null],
      puLocation: [null],
      notes: [null],
      street: [null],
      city: [null],
      state: [null],
      zipcode: [null],
      address: [null],
      country: [null],
    },
    destination: {
      id: [],
      name: [null],
      appointment: [new Date()],
      openAppointment: [null],
      referenceNumber: [null],
      notes: [null],
      street: [null],
      city: [null],
      state: [null],
      zipcode: [null],
      address: [null],
      country: [null],
    },
    container: {
      line: null,
      deliveryContainerNumber:'',
      pickupContainerNumber:'',
      bookingNumber: null,
      containerId: null,
      lastFreeDate: null,
      notes: null,
      isCustomDropLocation: false,
      dropLocation: '',
    },
    chassis: {
      company: null,
      chassisId: null,
      chassisNumber:'',
      isChassisSplit: false,
      pickupChassisCompany: null,
      pickupChassisId: null,
      pickupChassisNumber: null,
      isPickupChassisSplit: false,
    },
    equipment: {
      type: null,
      trailer: null,
      length: '',
      weight: '',    
    }
  };
  const [transportationMode, setTransportationMode] = useState(location && location.pathname.includes('intermodal') ? 'INTERMODAL' : 'OTR');
  const [order, setOrder] = useState(initState);
  const [action, setAction] = useState('Save');
  const [dispatchMode, setDispatchMode] = useState('TODAY');
  const [viewMode, setViewMode] = useState('GRID'); //other view is TABLE
  

  /* Dispatch Mode Logic */
  const [isDispatchModeMenuOpen, setDispatchModeMenuOpen] = useState(false);
  const [anchorRef, setAnchorRef] = useState(null);
  const [dispatchDate, setDispatchDate] = useState(new Date());

  /* Search State */
  const [isSearchEnabled, setSearchEnable] = useState(false);
  const [searchParameters, setSearchParameters] = useState({});

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(1000);
  const [orderCount, setOrderCount] = useState(500);
  const [nextPageLoading, setNextPageLoading] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const [orderStats, setOrderStats] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [originMarkers, setOriginMarker] = useState([]);
  const [destinationMarkers, setDestinationMarker] = useState([]);

  /* DIALOGS */
  const [isOrderFormDialogOpen, setOrderFormDialogOpen] = useState(false);
  const [isOrderDetailDialogOpen, setOrderDetailDialog] = useState(false);
  const [isOrderStatsDialogOpen, setOrderStatsDialog] = useState(false);
  const [isOrderHistoryDialogOpen, setOrderHistoryDialog] = useState(false);
  const [isDeleteOrderDialogOpen, setDeleteOrderDialog] = useState(false);
  const [isOrderMapDialogOpen, setMapDialog] = useState(false);
  const [isFileUploadDialogOpen, setFileUploadDialog] = useState(false);
  const [isInvoiceDialogOpen, setInvoiceDialog] = useState(false);
  const [isAdvanceSearchDialogOpen, setAdvanceSearchDialog] = useState(false);
  const [isNotificationDialogOpen, setNotificationDialog] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  const fileModalChildRef = useRef(null);

  useEffect(() => {
    if(dispatchMode == 'ALL ORDERS') {
      dispatch(OrderAction.getAllOrders(page, pageSize)); // Get All Orders
    } else if(dispatchMode === 'NO APPOINTMENT ORDERS') {
      dispatch(OrderAction.getOrdersByAppointment('NO', null, null, page, pageSize)); // Get No Appointment Orders
    } else {
      const startDate = new Date(dispatchDate.setHours(0, 0, 0, 0)); // dispatchDate by default is Today's date
      const endDate = new Date(dispatchDate.setHours(23, 59, 59, 999));
      const startDateISO = startDate.toISOString();
      const endDateISO = endDate.toISOString();
      dispatch(OrderAction.getOrdersByAppointment('YES', startDateISO, endDateISO, page, pageSize)); // Get Appointment orders By Date
    }
    // return dispatch(OrderAction.fetchDataPeriodically());
  }, [dispatchMode, dispatchDate, page]);

  /* When Dispatch Mode changes or date changes we need to make API call to pull orders */
  /* Dispatch mode menu */
  const handleDispatchModeChange = (evt) => {
    const mode = evt.currentTarget.textContent;
    if (mode === 'TODAY') {
      setDispatchDate(new Date()); //reset to today's date.
    }
    setDispatchMode(mode);
    setDispatchModeMenuOpen(false);
  };

  const handleDateChange = (evt) => {
    const dd = new Date(evt);
    const customDate = new Date(dd.setMinutes(dd.getMinutes() + dd.getTimezoneOffset())); //Need this for firefox. otherwise for chrome we can use datetime-local.
    setDispatchDate(customDate);
    setDispatchMode(customDate.toDateString()); // Show user which date they have selected.
    setDispatchModeMenuOpen(false);
  };

  const handleNextPage = (evt) => {
    setPage((prevPage) => prevPage + 1);
  };
  /* Table or Grid View */
  const toggleViewMode = () => {
    const newViewMode = viewMode === 'GRID' ? 'TABLE' : 'GRID';
    setViewMode(newViewMode);
  };

  const addOrder = () => {    
    setAction('Save');
    setOrderFormDialogOpen(true);
  };

  const editOrder = (row) => {
    const dispatchOrder = Validate.parseDispatchOrder(row);
    setOrder(dispatchOrder);
    setAction('Update');
    setOrderFormDialogOpen(true);
  };

  const processOrderPersist = (order) => {
    const { summary, origin, destination, container, chassis } = order;
    
    // Add the Order Creation Date
    summary.orderCreateDate = new Date();
    summary.broker = summary.broker.value;
    const temp = summary.expenses.map(exp => ({...exp, category: exp.category, categoryDescription: exp.categoryDescription}));
    summary.expenses = temp;
    origin.name = origin.name.map(o=>o.value);
    destination.name = destination.name.map(d=>d.value);
    container.line = container.line && container.line.value;
    chassis.company = chassis.company && chassis.company.value;
      
    const dispatchOrder = Object.create(null);

    dispatchOrder.summary = summary;
    dispatchOrder.origin = origin;
    dispatchOrder.destination = destination;
    dispatchOrder.container = container;
    dispatchOrder.chassis = chassis;

    if(action === 'Save') {
      dispatch(OrderAction.save(dispatchOrder));
    } else {
      dispatch(OrderAction.update(order));//order is already in same format
    }
  };

  const toggleDeleteOrder = (order) => {
    setSelectedOrder(order);
    setDeleteOrderDialog(!isDeleteOrderDialogOpen);
  };
  const processDeleteOrder = () => {
    const orderId = selectedOrder.id;
    dispatch(OrderAction.deleteOrder(orderId));
  };

  const closeDeleteOrderDialog = () => {
    dispatch(OrderAction.reset('RESET_TOAST_STATE'));
    setDeleteOrderDialog(false);
  };

  const toggleOrderDetail = (order) => {
    props.setActiveOrder(order); // similar to props.getOrderById()
    setSelectedOrder(order);
    setOrderDetailDialog(!isOrderDetailDialogOpen);
  };

  const closeFormDialog = () => {
    dispatch(OrderAction.reset('RESET_TOAST_STATE'));
    setOrder(initState);
    setOrderFormDialogOpen(false);
  };

  /* Order Properties */
  const processOrderStats = (order) => {
    if (isOrderStatsDialogOpen) {
      setSelectedOrder(null);
      setOrderStats([]);
      setOrderStatsDialog(false);
    } else {
      getOrderTimingStats(order.id).then((res) => {
        setSelectedOrder(order);
        setOrderStats(res.data);
        setOrderStatsDialog(true);
      });
    }
  };

  const processFileUpload = (order) => {
    if (isFileUploadDialogOpen) {
      setFileUploadDialog(false);
      setSelectedOrder(null);
    } else {
      setSelectedOrder(order);
      getFilesByOrderId(order.id, transportationMode === 'OTR')
        .then((res) => {
          if (res.status === 200 && res.data) {
            // res.data
            fileModalChildRef.current.onInit(res.data);
          }
        })
        .catch((e) => {
          // pass error
          fileModalChildRef.current.onInit(null, e);
        });
      setFileUploadDialog(true);
    }
  };

  const downloadOrderCSV = () => {
    const filename = 'orders.csv';
    const { orders } = props;

    const formattedOrders = [];
    const header = ['OrderId', 'OrderType', 'Broker', 'Broker Order Number', 'Rate', 'FSC', 'Status', 'Container Num', 'Line', 'Chassis Number', 'Company', 'CompleteDate', 'Payment Status', 'Notes'];
    const subHeader = ['', 'LegId', 'Origin', 'Destination', 'Leg Status', 'Driver', 'Driver Rate'];

    formattedOrders.push(header);

    orders.forEach(function (order) {
      const { legs, broker, container, chassis } = order;
      let containerNumber = container.deliveryContainerNumber;
      if (order.orderType === 'PICKUP') {
        containerNumber = container.pickupContainerNumber;
      }

      let arr = [order.displayOrderId, order.orderType, broker.name, order.brokerOrderNumber, formatCurrency(order.orderRate), formatCurrency(order.fuelCharges) || 0.0, order.status, containerNumber, container.line, chassis.chassisNumber, chassis.company, order.orderCompleteDate, order.paymentStatus, order.notes];
      formattedOrders.push(arr);
      formattedOrders.push(['']);
      formattedOrders.push(subHeader);
      legs.forEach(function (leg) {
        const origins = leg.origins.map(lo => lo.name);
        const destinations = [];
        leg.destinations.forEach(ld => {
          if (ld.active)
            destinations.push(ld.name);
        });
        const driverName = leg.driver ? leg.driver.fullName : 'N.A';
        const driverRate = leg.driver ? leg.driver.rate : 'N.A';
        arr = ['', leg.id, origins, destinations, leg.status, driverName, driverRate];
        formattedOrders.push(arr);
      });
      formattedOrders.push(['']);
      formattedOrders.push(['']);
    });
    let csvContent = 'data:text/csv;charset=utf-8,';
    formattedOrders.forEach(function (rowArray) {
      let row = rowArray.join(',');
      csvContent += row + '\r\n';
    });
    const data = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
  };

  const countOrdersByStatus = (data) => {
    const result = {};
    ['OPEN', 'PROGRESS', 'YARD', 'DELIVERED', 'COMPLETE'].forEach(status => {
      if (status === 'YARD') {
        const YARD = ['YARD_IN', 'YARD_PULL', 'DRYRUN'];
        result[status] = data.filter(d => YARD.includes(d.status)).length;
      } else if (status === 'PROGRESS') {
        const PROGRESS = ['PROGRESS', 'COVERED'];
        result[status] = data.filter(d => PROGRESS.includes(d.status)).length;
      } else {
        result[status] = data.filter(d => d.status === status).length;
      }
    });
    return result;
  };

  /* Search */
  /* 
    1. User click on search icon to call executeSearch function.
    2. If status is 200, we will display the search results.
    3. A Chip with onDelete property will be created based on {key:value} in the search Parameters
  */
  const toggleAdvanceSearchDialog = () => {
    if(isAdvanceSearchDialogOpen) {
      executeSearch(searchParameters);
    }
    setAdvanceSearchDialog(!isAdvanceSearchDialogOpen);
  };

  const handleSearchFieldChange = (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;
    const param = {};
    param[`${name}`] = value.trim();
    setSearchParameters(Object.assign(searchParameters, param));
  };

  /* Execute Search and also save state of the search variables */
  const executeSearch = (searchParameters) => {
    if (searchParameters && Object.entries(searchParameters).length > 0) {
      const params = {
        searchParam: Object.entries(searchParameters).map(([k, v]) => ({ 'label': k, 'value': v }))
      };
      setSearchEnable(true);
      setSearchParameters(searchParameters);
      setAdvanceSearchDialog(false);
      props.search(params);
    } else {
      setSearchEnable(false);
      setSearchParameters({});
      setAdvanceSearchDialog(false);

    }
  };

  /* Create Search Chip */
  const createSearchChip = () => {
    const kvpair = Object.entries(searchParameters).map(([k, v]) => ({ 'key': k, 'value': v }));
    const chips = kvpair.map(item => {
      return <Chip key={item.key}
        label={item.value}
        onDelete={(evt) => deleteSearchChip(evt, item.key)}
        color='secondary'
        size='small'
        style={{marginRight: 5}}
      />;
    });
    return chips;
  };
  /* Delete Search Chip and execute Search */
  const deleteSearchChip = (evt, key) => {
    clearSearchField(evt, key);
    // Execute search on remaining search items if any.
    executeSearch(searchParameters);
  };

  /* 
  Clear Search Fields - No need to perform search, because user has been given Search Button.
  */
  const clearSearchField = (evt, fieldName) => {
    const params = searchParameters;
    if(params[fieldName]) {
      delete params[fieldName];
      // We need to clear this filtered searchOption from the searchParameters and input box.
      Array.from(document.querySelectorAll('input')).forEach(input => {
        if (input.name === fieldName) //true
          input.value = null;
      });
      setSearchParameters(params);
    }
  };

  // Check the path to render the component
  const { orders, searched, activeOrder, isProcessing, toast } = props;

  const orderData = isSearchEnabled ? searched : orders;
  const orderCountByStatus = countOrdersByStatus(orderData);
  return (
    <Page
      title='Orders'
    >
      <Box display={'flex'} justifyContent={'space-between'}>
        <PageHeader
          title='ORDERS'
          subTitle={`Manage Your Intermodal Dispatch`}
        />
        <Searchbar
          searchType='ADVANCED'
          isAdvanceSearchDialogOpen={isAdvanceSearchDialogOpen}
          searchParameters={searchParameters}
          fnSearchMenuHandler={toggleAdvanceSearchDialog}
        >
          <Grid container spacing={2}>
            {SEARCH_FIELDS.map(field => {
              return (
                <Grid size={{xs: 6, sm:4}} key={field.name}>
                  <TextField
                    key={field.name}
                    label={field.label}
                    variant='outlined'
                    name={field.name}
                    type={field.type}
                    margin='none'
                    size='small'
                    fullWidth={true}
                    onChange={evt => handleSearchFieldChange(evt)}
                    InputProps={{
                      endAdornment: (<IconButton
                        name={field.name}
                        onClick={(evt) => clearSearchField(evt, field.name)}
                        size="large">
                        <CloseOutlined fontSize='small' />
                      </IconButton>
                      )
                    }}
                  />
                </Grid>
              );
            })
            }
          </Grid>
          <Box
            display='flex'
            justifyContent='flex-end'
            p={2}
          >
            <Button
              variant='contained'
              color='primary'
              onClick={() => executeSearch(searchParameters)}
            >
              Search
            </Button>
          </Box>
        </Searchbar>
        <Notificationbar />
      </Box>
      <Box
        m='20px 0 0 0'
        height='75vh'
      >
        <Box style={{ margin: '10px 0 10px' }}>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Button
              variant='contained'
              color='primary'
              onClick={addOrder}
            >
              {'New Order'}
            </Button>
            {isSearchEnabled &&
              <Box>
                <Box flex={1}>
                  {createSearchChip()}
                </Box>
                <Typography variant='caption'
                  sx={{
                    letterSpacing: 1,
                    color: '#667085',
                    textTransform: 'uppercase',
                    marginBottom: '2px',
                    textAlign: 'center',
                  }}
                >
                  {`${searched.length} records found`}
                </Typography>
              </Box>
            }
            <ButtonGroup size='small' variant='outlined' color='secondary' aria-label='split button'>
              <Button disabled>{dispatchMode}</Button>
              <Button
                onClick={(evt) => {
                  setDispatchModeMenuOpen(!isDispatchModeMenuOpen);
                  setAnchorRef(evt.currentTarget);
                }}
              >
                <ArrowDropDown />
              </Button>
              <Button onClick={downloadOrderCSV}><ImportExportOutlined /> </Button>
              <Button onClick={toggleViewMode}>
                {'CHANGE VIEW'}
              </Button>                    
            </ButtonGroup>
            <Popper
              open={isDispatchModeMenuOpen}
              anchorEl={anchorRef}              
              modifiers={{
                arrow: {
                  enabled: true,
                  element: anchorRef
                }
              }}
              transition disablePortal style={{ zIndex: 1500 }}>
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                  }}
                >
                  <Paper elevation={2}>
                    <ClickAwayListener onClickAway={() => setDispatchModeMenuOpen(false)}>
                      <MenuList id='split-button-menu'>
                        {DISPATCH_MODE.map((option) => (
                          <>
                            <MenuItem
                              key={option}
                              onClick={(event) => handleDispatchModeChange(event)}
                            >
                              <Typography variant='body1' style={{letterSpacing: 1}}>{option}</Typography>
                            </MenuItem>
                            <Divider />
                          </>                    
                        ))}
                        <Divider />
                        <Calendar
                          compact
                          onSelect={handleDateChange}
                          style={{ width: 240 }}
                          value={dispatchDate}
                          monthDropdownProps={<div></div>}
                        />  
                      </MenuList>          
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>
          {isProcessing && <Backdrop className='backDrop' style={{zIndex: 10000000}}
            sx={{ color: '#fff' }}
            open={true}>
              <CircularProgress style={{margin: '0px 50%', display: 'flex'}} />
          </Backdrop>}
          {toast ? <ToastHandler toast={toast} type={toast.type} /> : null}
        </Box>
        {viewMode === 'GRID' ?
          <Grid container spacing={1}>
            {INTERMODAL_STATUS.map(status =>
              <Grid key={status} size={{xs: 12, sm:5, md:3, lg: 2}} sx={{minWidth: '19%'}}>
                <SwimlaneHeader
                  variant='subtitle2'
                  style={{ color: getTabColor(status), textAlign: 'center' }}
                >
                  {status} ({orderCountByStatus[status]})
                </SwimlaneHeader>
                <DispatchGridView
                  orders={filterOrderDataByTab(orderData, status)}
                  transportationMode='INTERMODAL'
                  fnViewOrderHandler={toggleOrderDetail}
                  fnEditOrderHandler={editOrder}
                  fnDeleteOrderHandler={toggleDeleteOrder}
                  fnOrderStatsHandler={processOrderStats}
                  fnFileUploadHandler={processFileUpload}
                />
              </Grid>
            )}
          </Grid>:
          <DispatchTableView
            orders={orderData}
            transportationMode={'INTERMODAL'}
            page={page}
            pageSize={pageSize}
            rowCount={orderCount}
            fnViewOrderHandler={toggleOrderDetail}
            fnEditOrderHandler={editOrder}
            fnDeleteOrderHandler={toggleDeleteOrder}
            fnOrderStatsHandler={processOrderStats}
            fnFileUploadHandler={processFileUpload}
            fnOnPageChange={newPage => setPage(newPage)}
          />
        }
      </Box>
      {/* MAP DIALOG */}
      <DataDialog
        open={isOrderMapDialogOpen}
        width={'lg'}
        onCloseHandler={() => setMapDialog(false)}
      >
        <CTMap origins={originMarkers} destinations={destinationMarkers} />
      </DataDialog>
      {/* ORDER DETAIL DIALOG */}
      <ContentDrawer
        open={isOrderDetailDialogOpen}
        title='Load Detail'
        isProcessing={isProcessing}
        toast={toast}
        handleClose={() => toggleOrderDetail()}
      >
        <LoadDetail
          transportationMode='INTERMODAL'
          initialOrder={selectedOrder || activeOrder}
        />
      </ContentDrawer>
      {/* ORDER FORM DIALOG */}
      <FormDrawer
        open={isOrderFormDialogOpen}
        title={'Create Order'}
        toast={toast}
        isProcessing={isProcessing}
        handleClose={closeFormDialog}
      >
        <IntermodalLoadForm
          isEdit={action === 'Update'}
          orderForm={order}
          formAction={action}
          tabIndex={0}
          saveFormHandler={(order) => processOrderPersist(order)}
          updateFormHandler={(order) => processOrderPersist(order)}
          cancelDialogHandler={closeFormDialog}
        />
      </FormDrawer>
      {/* ORDER STATS DIALOG */}
      <DataDialog
        open={isOrderStatsDialogOpen}
        title={'Order Stats'}
        width={'md'}
        onCloseHandler={() => setOrderStatsDialog(false)}
      >
        <OrderStats
          title={'Order Stats'}
          orderStats={orderStats}
        />
      </DataDialog>
      {/* ORDER HISTORY DIALOG */}
      <DataDialog
        open={isOrderHistoryDialogOpen}
        title={'Order History'}
        width={'md'}
        onCloseHandler={() => setOrderHistoryDialog(false)}
      >
        <OrderStats
          title={'Order History'}
          orderHistory={orderHistory}
        />
      </DataDialog>
      {/* INVOICE DIALOG */}
      <DataDialog
        open={isInvoiceDialogOpen}
        title={'Order Invoice'}
        width={'md'}
        onCloseHandler={() => setInvoiceDialog(false)}
      >
        <InvoiceModal
          invoice={invoice || null}
        />
      </DataDialog>
      {/* NOTIFICATION DIALOG */}
      <NotificationDialog
        open={isNotificationDialogOpen}
        title={'Information'}
        width={'md'}
        onCloseHandler={() => setNotificationDialog(false)}
      >
        <Typography variant='h6'>{notificationMessage}</Typography>
      </NotificationDialog>
      <DataDialog
        open={isFileUploadDialogOpen}
        title={'Upload Documents'}
        width={'md'}
        onCloseHandler={() => setFileUploadDialog(false)}
      >
        <FilesModal
          isOTR={false}
          ref={fileModalChildRef}
          errorData={''}
          messageData={''}
          filesData={[]}
          orderId={selectedOrder && selectedOrder.id}
        />
      </DataDialog>
      <ConfirmationDialog
        open={isDeleteOrderDialogOpen}
        title={'Delete Order'}
        isProcessing={isProcessing}
        toast={toast}
        handleConfirm={processDeleteOrder}
        handleCancel={()=>closeDeleteOrderDialog(false)}
        handleCloseFunc={()=>closeDeleteOrderDialog(false)}
      >
        <Typography variant='subtitle2'>{`Delete Order: ${selectedOrder && selectedOrder.displayOrderId} `}</Typography>
        <Typography variant='body2' style={{color: 'rgb(255, 56, 56)'}}>Order delete will delete associated legs, expenses, driver charges, invoices and bills.</Typography>
        <Typography variant='subtitle2' style={{marginTop: '15px', textAlign: 'center'}}>{'Do you want to continue ?'}</Typography>
      </ConfirmationDialog>
    </Page>
  );
}

function mapStatesToProps(state) {
  // // Whatever is returned will show up as props inside of Orders
  const { orders, searched, order, isProcessing, toast } = state.orderReducer;
  return {
    orders,
    searched,
    activeOrder: order,
    isProcessing,
    toast
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(OrderAction, dispatch);
}

export default connect(mapStatesToProps, mapDispatchToProps)(IntermodalDispatch);